import TranslationTextArea from './TranslationTextArea';



export default TranslationTextArea;
